module.exports = __webpack_public_path__ + "img/ras-logo-negativo.ac79b284.svg";